<!--
 * @Descripttion: 
 * @version: 
 * @Author: yql
 * @Date: 2020-04-24 11:07:51
 * @LastEditors: yql
 * @LastEditTime: 2020-05-26 19:00:30
 -->

<template>
  <div class="login">
    <div class="content">
      <div class="text" style="font-size: 20px;font-weight: bold">设置密码</div>
      <div class="phoneBox">
        <div class="inputBox userName">
          <div class="inputer">
            <input
              type="tel"
              @blur="inputBlur"
              disabled
              placeholder="请输入在物业登记的手机号码"
              v-model="submitMode.mobile"
            />
          </div>
        </div>
        <div class="inputBox">
          <div class="inputer ">
            <input
              class="gray"
              @blur="inputBlur"
              type="password"
              v-model="submitMode.password"
              placeholder="请输入密码"
            />
          </div>
        </div>
      </div>
      <div class="getCode" style="padding-top: 20px;">
        <button class="btn" @click="handleReset()">
          设置
        </button>
      </div>
    </div>
    <view-footer></view-footer>
  </div>
</template>

<script>
import verifyCode from "./components/verifyCode";
export default {
  name: "forgetPwd",
  components: { verifyCode },
  data() {
    return {
      submitMode: {
        mobile: "",
        password: ""
      },
      redirect: null
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.submitMode.mobile = this.$route.query.mobile;
    this.windowResize();
  },
  methods: {
    inputBlur(e) {
      let str = e.target.value.toString();
      e.target.value = str.replace(/(^\s*)|(\s*$)/g, "");
      e.target.dispatchEvent(new Event("input"));
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      window.scrollTo(0, 0);
    },
    //浏览器窗口resize
    windowResize() {
      let self = this;
      let focusElem = document.getElementById("#inputLabel");
      window.addEventListener("resize", function() {
        if (focusElem && document.body.clientHeight < this.clientHeight) {
          //使用scrollIntoView方法来控制输入框
          focusElem.scrollIntoView(false);
        }
      });
    },

    //input失去焦点Event
    inputBlur() {
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      window.scrollTo(0, 0);
    },

    //登录
    handleReset() {
      if (!this.submitMode.password) {
        this.$confirm({
          mesg: "请输入新密码",
          cancel: false,
          btn: {
            confirmVal: "确 定"
          }
        });
        return false;
      }

      this.load.$emit("loading", true);
      this.$store.dispatch("user/editPwd", this.submitMode).then(result => {
        if (result.returnCode == 0) {
          this.$confirm({
            mesg: "设置成功",
            cancel: false,
            btn: {
              confirmVal: "确 定"
            }
          });
          this.$router.push("/property");
          this.load.$emit("loading", false);
        } else {
          this.load.$emit("loading", false);
          this.$confirm({
            mesg: result.returnMsg,
            cancel: false,
            btn: {
              confirmVal: "确 定"
            }
          });
        }
      });
    }
  }
};
</script>
